export const INDEX = '/'
export const run_2025 = '/2025'
export const run_2026 = '/2026'
